module.exports = __webpack_public_path__ + "static/media/inspire-logo.e7de417e.png";